module.exports = __webpack_public_path__ + "static/media/barcode.7614be18.svg";